export const SpecialAlloysgrade = [
  {
    id: 1,
    heading: "Inconel Alloys",
    link: "/SpecialAlloys/InconelAlloys",
    data: {
      text1:
        "Inconel Alloys 600, 601, 625, 718, 800, 825 Supplier,Inconel Round Bars & Wires, Inconel Pipes & Tubes, Incoloy Alloy Sheets & Plates, Inconel Flanges & Pipe Fittings Stockiest & Exporters in India",
      text2:
        "Inconel Alloys are combo of nickel and chromium which have variety of applications. The specialty of these alloys is, they can withstand at both extreme pressures and elevated temperature. Nakshatra Steel & Alloys is an exemplary Inconel Alloys supplier in the contemporary market.",
      text3:
        "Inconel Sheets & Plates have innumerous applications in Chemical and Petrochemical Processing industries. Inconel Pipe Fittings are employed in Heat exchangers and Pressure Vessels. Our Inconel Fasteners are equipped in super heaters and re-heaters in Power plants.",
      text4:
        "Inconel Tube Fittings are utilized in Hydrocarbon cracking and Ethylene Furnace Quench Boilers. Our Inconel Tube Round Bars are used in heat treating equipment in Industrial furnaces. Please contact us today to request a free estimate on all types of Inconel alloys products!",
    },
    grade: [
      "Inconel alloy 625",
      "Inconel alloy 601",
      "Inconel alloy 601GC",
      "Inconel alloy 617",
      "Inconel alloy 600",
      "Inconel alloy 625LCF",
      "Inconel alloy 690",
      "Inconel alloy 693",
      "Inconel alloy 718",
      "Inconel alloy 718SPF",
      "Inconel alloy 783",
      "Inconel alloy 6022",
      "Inconel alloy 7740",
      "Inconel alloy 603XL",
      "Inconel alloy 686",
      "Inconel alloy 706",
      "Inconel alloy 725",
      "Inconel alloy 740",
      "Inconel alloy X-750",
      "Inconel alloy 751",
      "Inconel alloy MA754",
      "Inconel alloy MA758",
      "Inconel alloy N06230",
      "Inconel alloy C-276",
      "Inconel alloy G-3",
      "Inconel alloy HX",
      "Inconel alloy 22",
    ],
    products: [
      "Inconel Pipes",
      "Inconel Tubes",
      "Inconel Flanges",
      "Inconel Pipe Fittings",
      "Inconel Forged",
      "Fittings	Inconel Fasteners",
      "Inconel Tube Fittings",
      "Inconel Round Bars",
      "Inconel Sheets & Plates",
    ],
  },
  {
    id: 2,
    heading: "Monel Alloys",
    link: "/SpecialAlloys/SuperMonelAlloys",
    data: {
      text1:
        "India’s Leading Monel Alloy 400 / K500 Supplier Monel Round Bars & Wires, Monel Alloy Pipes & Tubes, Monel Sheets & Plates, Monel Alloy Flanges & Pipe Fittings Stockiest & Exporters in India",
      text2:
        "Monel Alloy is noted for its exceptional properties. It is a combination of nickel and copper as primary elements, and manganese, iron, copper, and silicon as secondary elements. Nakshatra Steel & Alloys is a renowned Monel Alloys Supplier. We adapt phenomenal methods like machining, welding, hot working and cold working to fabricate Monel 400 and Monel K500.",
      text3:
        "Monel Pipes & Tubes are resistant to many precarious chemicals and seawater.. Monel Pipe Fittings manufactured by us sustain strength in elevated temperatures as well. On the other hand our Monel Flanges remain ductile without becoming brittle though they are cooled extremely. These flanges are tough and durable though they are expensive than Stainless Steel Flanges. Thus we can say that they are more ductile compared to many ferrous flanges that become brittle easily.",
      text4:
        "Monel Tube fittings are employed in aircraft construction as they retain their dimensions though they come across with heat. Monel Round Bars are invulnerable to sulfuric, hydrochloric, and hydrofluoric acid; hence it is implemented in the department of alkylation units. They also have many marine applications as well. We have well trained and experienced team to design Monel Sheets & Plates with dimensional accuracy. Contact us with your requirements and we assure you to offer products that meet your specific needs and demands!",
    },
    grade: [],
    products: [
      "Monel 400 Pipes",
      "Monel 400 Tubes",
      "Monel 400 Pipe Fittings",
      "Monel 400 Forged Fittings",
      "Monel 400 Fasteners	Monel",
      "400 Tube Fittings",
      "Monel 400 Round Bars",
      "Monel 400 Flanges",
      "Monel 400 Sheets",
      "Monel 400 Plates",
      "Monel K500 Pipes",
      "Monel K500 Tubes",
      "Monel K500 Pipe Fittings",
      "Monel K500 Forged Fittings",
      "Monel K500 Fasteners",
      "Monel K500 Tube Fittings",
      "Monel K500 Round Bars",
      "Monel K500 Flanges",
      "Monel K500 Sheets",
      "Monel K500 Plates",
    ],
  },

  {
    id: 3,
    heading: "Hastelloy",
    link:"/SpecialAlloys/Hastelloy",
    data: {
      text1:
        "Highly Acclaimed Hastelloy C276 / Hastelloy C22 Supplier in India ,Hastelloy Round Bars & Wires, Hastelloy Pipes & Tubes, Hastelloy Sheets & Plates, Hastelloy Fasteners, Hastelloy Flanges & Hastelloy Pipe Fittings Stockiest & Exporters in India",
      text2:
        "Hastelloy is considered to have excellent resistance towards corrosion. There are many other alloys which have exceptional properties, and Hastelloy is one among them. It is said to have withstanding capability towards elevated temperatures and stress. Thence it is employed in many industries for special purposes.",
      text3:
        "We manufacture Hastelloy Pipes & Tubes which tend to exhibit considerable resistance towards all kinds of pitting and cracking. Chemical mechanisms deploy our Hastelloy Flanges as they have the ability to combat oxidation. Hastelloy Pipe Fittings are tough and durable even in chemically inert atmospheres and vacuum. Hastelloy Fasteners can successfully function under medium to high temperature ranges.",
      text4:
        "Our Hastelloy Tube Fittings have their own special purpose utilizations in Chemical reactors and Nuclear reactors. Hastelloy Sheets & Plates have wide variety of applications in Petrochemical and Chemical Processing industries. Our Hastelloy Round Bars are employed in heat exchangers and pressure vessels.",
    },grade: [],
    products: [
      "Hastelloy C276 & C22 Pipes",
      "Hastelloy C276 & C22 Tubes",
      "Hastelloy C276 & C22 Pipe Fittings",
      "Hastelloy C276 & C22 Forged Fittings",
      "Hastelloy C276 & C22 Fasteners",
      "Hastelloy C276 & C22 Tube Fittings",
      "Hastelloy C276 & C22 Round Bars",
      "Hastelloy C276 & C22 Flanges",
      "Hastelloy C276 & C22 Sheets",
      "Hastelloy C276 & C22 Plates",
    ],
  },
  {
    id: 4,
    heading: "Duplex Alloys",
    link:"/SpecialAlloys/DuplexAlloys",
    data: {
      text1:
        "Top Duplex Steel 2205 / Duplex Steel 2304  Supplier in India,Duplex Steel Round Bars & Rods, Duplex Steel Pipes & Tubes, Duplex Steel Sheets & Plates, Duplex Steel Fasteners, Duplex Steel Flanges & Duplex Steel Pipe Fittings Stockiest & Exporters in India",
      text2:
        "Duplex Steel is a combination of austenite and ferrite in equal quantities. It is noted for its marvellous corrosion resistance and satisfying mechanical properties. Duplex steel products have wide range of industrial applications for their pleasing features. They also exhibit considerable resistance towards stress corrosion cracking.",
      text3:
        "Compared to other flanges and fasteners, Duplex Steel Flanges and Duplex Steel Fasteners are two times tough and strong. We boost up our Duplex Steel Pipes & Tubes by adding small quantities of nitrogen, chromium, and molybdenum. Duplex Steel Pipe Fittings are invulnerable to chloride pitting and crevice corrosion.",
      text4:
        "Compared to other flanges and fasteners, Duplex Steel Flanges and Duplex Steel Fasteners are two times tough and strong. We boost up our Duplex Steel Pipes & Tubes by adding small quantities of nitrogen, chromium, and molybdenum. Duplex Steel Pipe Fittings are invulnerable to chloride pitting and crevice corrosion.",
    },grade: [],
    products: [
      " Duplex 2205 & 2304 Pipes",
      "Duplex 2205 & 2304 Tubes",
      "Duplex 2205 & 2304 Pipe Fittings",
      "Duplex 2205 & 2304 Forged Fittings",
      "Duplex 2205 & 2304 Fasteners",
      "Duplex 2205 & 2304 Tube Fittings",
      "Duplex 2205 & 2304 Round Bars",
      "Duplex 2205 & 2304 Flanges",
      "Duplex 2205 & 2304 Sheets",
      "Duplex 2205 & 2304 Plates",
    ],
  },
  {
    id: 5,
    heading: "Super Duplex Alloys",
    link: "/SpecialAlloys/SuperDuplexAlloys",
    data: {
      text1:
        "Super Duplex Steel S32750 / S32760 Supplier in India,Super Duplex Round Bars & Wires, Super Duplex Seamless Pipes, Super Duplex Welded Tubes, Super Duplex Plain Sheets & Plates, Super Duplex Fasteners, Super Duplex Flanges & Super Duplex Buttweld Pipe Fittings Stockiest & Exporters in India",
      text2:
        "Super Duplex Steel is a material designed with higher quantities of nitrogen, molybdenum, and chromium. Super Duplex Steel Products possess more durability and tenacity compared to products that are fabricated using Duplex Steel. Though the elements used for manufacturing both the alloys are same, the ratio of the composition used varies. This makes the former one more corrosion resistant than the latter one.",
      text3:
        "Our products like Super Duplex Steel S32750 and Super Duplex Steel S32760 have wide variety of industrial applications for their exemplary features. Due to the exceptional physical properties of our Super Duplex Round Bars and Super Duplex Flanges, they are employed in marine and oil & gas industries.",
      text4:
        "On the other hand, our Super Duplex Steel Pipes & Tubes have special utilizations in petrochemical and mining industries. Our Super Duplex Steel Fasteners and Super Duplex Steel Pipe Fittings are durable and ductile. We use high quality raw material to manufacture Super Duplex Steel Sheets & Plates. Our eminent team is always reachable to respond to your queries. Contact us today; we have all the products readily available in the stock. ",
    },grade: [],
    products: [
      "Super Duplex S32750 & S32760 Pipes",
      "Super Duplex S32750 & S32760  Tubes",
      "Super Duplex S32750 & S32760  Pipe Fittings",
      "Super Duplex S32750 & S32760  Forged Fittings",
      "Super Duplex S32750 & S32760  Fasteners",
      "Super Duplex S32750 & S32760  Tube Fittings",
      "Super Duplex S32750 & S32760  Round Bars",
      "Super Duplex S32750 & S32760  Flanges",
      "Super Duplex S32750 & S32760  Sheets",
      "Super Duplex S32750 & S32760  Plates",
    ],
  },
  {
    id: 6,
    heading: "Cupro Nickel Alloys",
    link: "/SpecialAlloys/CuproNickelAlloys",
    data: {
      text1:
        "Best Cupro Nickel (CU-Ni) 70/30 & 90/10 Supplier in India,Cupro Nickel Round Bars & Wires, Cupro Nickel Seamless Pipes, Cupro Nickel Welded Tubes, Cupro Nickel Plain Sheets & Plates, Cupro Nickel Fasteners, Cupro Nickel Flanges & Cupro Nickel Pipe Fittings Stockiest & Exporters",
      text2:
        "Cupro Nickel is an alloy with Copper and Nickel as primary elements, and Iron and Manganese as secondary elements. This silver coloured alloy has wide variety of applications for its distinguished properties. Cupro nickel products are deployed in mechanical industries for the purpose of desalination materials, armaments manufacture, and marine engineering.",
      text3:
        "For the exquisite features of our Cupro Nickel (Cu-Ni) 90/10 and Cupro Nickel (Cu-Ni) 70/30 they are deployed in shipbuilding and power generation. Our Cupro Nickel 70/30 Pipes & Tubes are used in marine environment for their exemplary pitting and corrosion resistance. We manufacture Cupro Nickel Flanges that have the ability to combat all types of corrosions in seawater.",
      text4:
        "Our Copper Nickel Fasteners and Copper Nickel Pipe Fittings are implemented in marine hardware, piping, and condensers & exchangers in seawater equipment. Copper Nickel Tube Fittings are deployed in high pressure systems and condensers in the Seawater system design. Cu-Ni 90/10 Round Bars and Cu-Ni 70/30 Sheets & Plates are used in evaporator tubing and brine heaters. Please give us a call today for your all copper nickel product requirement! ",
    },grade: [],
    products: [
      "Cupro Nickel 70/30 & 90/10 Pipes",
      "Cupro Nickel 70/30 & 90/10 Tubes",
      "Cupro Nickel 70/30 & 90/10 Pipe Fittings",
      "Cupro Nickel 70/30 & 90/10 Forged Fittings",
      "Cupro Nickel 70/30 & 90/10 Fasteners",
      "Cupro Nickel 70/30 & 90/10 Tube Fittings",
      "Cupro Nickel 70/30 & 90/10 Round Bars",
      "Cupro Nickel 70/30 & 90/10 Flanges",
      "Cupro Nickel 70/30 & 90/10 Sheets",
      "Cupro Nickel 70/30 & 90/10 Plates",
    ],
  },
  {
    id: 7,
    heading: "SMO 254",
    link: "/SpecialAlloys/SMO254",
    data: {
      text1:
        "Leader Supplier of SMO 254 / UNS S31254 Products in India,SMO 254 Round Bars & Wires, SMO 254 Seamless Pipes, SMO UNS S31254 Welded Tubes, SMO 254 Plain Sheets & Plates, SMO UNS S31254 Fasteners, SMO 254 Flanges & SMO 254 Pipe Fittings Stockiest & Exporters",
      text2:
        "SMO 254 Grade of Stainless Steel is a compound made up of austenite. It is noted for its exquisite towards pitting, crevice corrosion, and chloride stress corrosion cracking. When compared to Titanium and nickel alloys these SMO 254 products are available at affordable price ranges. Hence they are preferred for many machinery purposes.",
      text3:
        "While fabricating our SMO 254 Pipe Fittings, we perform the annealing process by heating the material at greater temperatures and then water quenching them. Proper measures are taken while hot working and cold working in the manufacturing process of SMO 254 Fasteners.",
      text4:
        "Our SMO 254 Tube Fittings have wide variety of applications in petroleum production. SMO 254 Round Bars are equipped in chemical and food processing industries. On the other hand, SMO 254 Plates and SMO 254 Sheets are employed in desalination and flue-gas cleaning purposes. Please contact us to request a free quote or to speak with one of our experts on SMO 254 products!",
    },grade: [],
    products: [
      "SMO 254 & UNS S31254 Pipes",
      "SMO 254 & UNS S31254 Tubes",
      "SMO 254 & UNS S31254 Pipe Fittings",
      "SMO 254 & UNS S31254 Forged Fittings",
      "SMO 254 & UNS S31254 Fasteners",
      "SMO 254 & UNS S31254 Tube Fittings",
      "SMO 254 & UNS S31254 Round Bars",
      "SMO 254 & UNS S31254 Flanges",
      "SMO 254 & UNS S31254 Sheets",
      "SMO 254 & UNS S31254 Plates",
    ],
  },
  {
    id: 8,
    heading: "Alloy 20",
    link: "/SpecialAlloys/Alloy20",
    data: {
      text1:
        "Alloy 20 / UNS N08020 / Alloy 20 WNR 2.4660 Supplier in India,Alloy 20 Round Bars & Wires, Alloy 20 Seamless Pipes, Alloy UNS N08020 Welded Tubes, Alloy 20 Plain Sheets & Plates, Alloy 20 UNS N08020 Fasteners, Alloy 20 Flanges & Alloy 20 Pipe Fittings Stockiest & Exporters",
      text2:
        "Alloy 20 is a special compound which is particularly utilised in the applications involving sulphuric acid. It is generally a combo of nickel, chromium and molybdenum. It exhibits exclusive resistance towards pitting and corrosion due to which Alloy 20 products are deployed in plastic, food, power generation, and pharmaceutical industries.",
      text3:
        "Our Alloy 20 Pipes & Tubes exhibit exceptional properties like resistance towards crevice corrosion and harmful chemicals like phosphoric, chlorides, sulphuric, and nitric acids. We enhance our Alloy 20 Flanges with small quantities of niobium which helps them to combat intergranular corrosion and sensitization.",
      text4:
        "Alloy 20 Fasteners are used in synthetic manufacturing machinery. Our Alloy 20 Pipe Fittings have wide range of applications in production of dye and food. Alloy 20 Tube fittings are deployed in petrochemical process systems and bubble caps. Our Alloy 20 Round Bars are adapted in reactor vessels and chemical piping systems. Alloy 20 Sheets and Alloy 20 Plates are employed in the manufacturing process of pumps and valves.",
    },grade: [],
    products: [
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Pipes",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Tubes",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Pipe Fittings",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Forged Fittings",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Fasteners",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Tube Fittings",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Round Bars",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Flanges",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Sheets	",
      "Alloy 20 & UNS N08020,20 WNR 2.4660 Plates",
    ],
  },
  {
    id: 9,
    heading: "Titanium",
    link: "/SpecialAlloys/TitaniumAlloys",
    data: {
      text1:
        "Titanium Alloys Grade.1, Grade.2, Grade.5,Grade.7,Grade.11, Supplier, Round Bars & Wires,Pipes & Tubes, Titanium Alloy Sheets & Plates, Titanium Flanges & Pipe Fittings Stockiest & Exporters in India",
      text2:
        "Titanium shows a long working life and the ability to work extremely high to low-temperature fluctuations. Furthermore, our team of quality experts ensures the capacity of the finished product to withstand various wokr conditions. ",
      text3:
        "Modi Metals is a famous organization that has gained a preeminent position as a supplier, wholesaler, and exporter of Titanium in all Grade. Our company has owned a team of specialists who assist us in producing a broad range of Titanium products. We choose a superior quality of Titanium in all Grade , which is soft and malleable. Besides, the grade offers the greatest formability. We choose unalloyed Titanium grade, which offers outstanding corrosion resistance abilities, weldability and useful in various applications. The material is largely applied in marine and chemical industries. The selected material grade holds the capacity to sustain in harsh environments for a longer time. Titanium is also useful in the fabrication of anode materials to carry out cathode operations.",
      text4:
        " we strive to go with the latest industrial trends and use modular production procedures and test tools. We aim to make our products popular in the market, and for that, we work hard. To maintain quality standards, we are strictly bound to follow globally accepted and industrially suitable standards for titanium all grades ",
    },
    grade: [
      "Titanium Grade.1 ",
      "Titanium Grade.2",
      "Titanium Grade.5",
      "Titanium Grade.7",
      "Titanium Grade.11",
    
    ],
    products: [
      "Titanium In Gr.2,5,7,11 Pipes",
      "Titanium In Gr.2,5,7,11 Tubes",
      "Titanium In Gr.2,5,7,11 Flanges",
      "Titanium In Gr.2,5,7,11 Pipe Fittings",
      "Titanium In Gr.2,5,7,11 Forged",
      "Titanium In Gr.2,5,7,11 Fasteners",
      "Titanium In Gr.2,5,7,11 Tube Fittings",
      "Titanium In Gr.2,5,7,11 Round Bars",
      "Titanium In Gr.2,5,7,11 Sheets & Plates",
    ],
  },
];
